import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

const EXTRAS = ["Vasad", "Anand", "Nadiad", "Karamsad", "Dabhoi", "Sinor", "Pratapgunj", "Chhani", "Manjalpur", "Gotri", "Sayajigunj", "Fatehgunj"];

export default function Coverage() {
    const [zones, setZones] = useState([]);
    useEffect(() => {
        api.get("/pricing").then(r => setZones(r.data.service_areas || [])).catch(() => {});
    }, []);
    const all = [...zones, ...EXTRAS];
    return (
        <div className="bg-white min-h-screen py-16" data-testid="coverage-page">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-xs font-mono-plex uppercase tracking-[0.2em] text-blue-700 mb-4">// Service Coverage</div>
                <h1 className="font-heading font-black text-5xl md:text-6xl tracking-tighter text-slate-900 leading-tight max-w-3xl">
                    From Vadodara city core to the industrial belt.
                </h1>
                <p className="mt-6 text-slate-600 max-w-2xl leading-relaxed">
                    We currently deliver across Vadodara district and neighbouring industrial hubs. Don't see your location listed? Contact us — we onboard new pincodes every week.
                </p>

                <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-slate-200 border border-slate-200">
                    {all.map((z) => (
                        <div key={z} className="bg-white p-6 hover:bg-blue-50 transition-colors flex items-center gap-3" data-testid={`coverage-zone-${z.toLowerCase()}`}>
                            <MapPin className="w-5 h-5 text-blue-700" />
                            <span className="font-heading font-bold text-slate-900">{z}</span>
                        </div>
                    ))}
                </div>

                <div className="mt-16 bg-slate-900 text-white p-10 rounded-sm flex flex-col md:flex-row items-center justify-between gap-6">
                    <div>
                        <h3 className="font-heading font-black text-3xl tracking-tighter">Location not listed?</h3>
                        <p className="mt-2 text-slate-400">Call our dispatch team — we may still be able to serve you.</p>
                    </div>
                    <Link to="/contact">
                        <Button className="rounded-sm bg-blue-700 hover:bg-blue-800 h-12 px-8 font-bold uppercase tracking-wider" data-testid="coverage-contact-btn">
                            Contact Sales <ArrowRight className="ml-2 w-4 h-4" />
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
}
